import React, { forwardRef, useEffect, useState } from "react";
import LoanRecallsGrid from "./LoanRecallsGrid";
import _ from "lodash";
import {
  getRecallDetails,
  getRecallDetailsAndOutstandingLoans,
  isServiceHealthy,
} from "../../utils/API";
import { useNavigate } from "react-router";
import withUser from "../../redux/HOC/withUser";
import {
  debounceGlobalSearch,
  getTimeStamp,
} from "../../common/commonFunctions";
import SpinnerFullScreen from "../../components/SpinnerFullScreen";
import SearchIcon from "@mui/icons-material/Search";
import excel from "../../assets/images/excel.svg";
import RefreshIcon from "@mui/icons-material/Refresh";
import { exportMultipleSheetsAsExcel } from "ag-grid-enterprise";
import moment from "moment";
import {
  constants,
  EndPoint,
  messages,
  recallMetricFilters,
  socketMsgType,
} from "../../common/constants";
import BorrowRecallsGrid from "./BorrowRecallsGrid";
import SockJS from "sockjs-client";
import {
  BASE_URI_SOCKET,
  envs,
  getEnv,
  serviceAPIMapping,
} from "../../config/service-api-mapping";
import { Stomp } from "@stomp/stompjs";
import { Split } from "@geoffcox/react-splitter";
import "../../common/style.css";
import "./style.css";
import KPIComponent from "../../components/KPIComponent";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { Recall } from "../../common/types/recall";
import RecallActivity from "../../components/RecallActivity";
import { Modal } from "react-bootstrap";
import ContractRecall from "../../components/ContractRecall";
import { Card, CardContent } from "@mui/material";

const Recalls = (props: any) => {
  const [lastRefresh, setLastRefresh] = useState<any>("");
  //const dtcSocket = new SockJS(`${BASE_URI_DTC_SOCKET()}`);
  const [borrows, setBorrows] = useState<Recall[]>([]);
  const [initialBorrows, setInitialBorrows] = useState<Recall[]>([]);
  const [loans, setLoans] = useState<Recall[]>([]);
  const [initialLoans, setInitialLoans] = useState<Recall[]>([]);
  const [selectedCusip, setSelectedCusip] = useState<any>(null);
  const [selectedTicker, setSelectedTicker] = useState<any>(null);
  const [selectedTickerCusip, setSelectedTickerCusip] = useState<any>(null);
  const [isLoansProcessing, setIsLoansProcessing] = useState<boolean>(false);
  const [isBorrowsProcessing, setIsBorrowsProcessing] =
    useState<boolean>(false);
  const navigate = useNavigate();
  const [globalSearch, setGlobalSearch] = useState<string>("");
  const [accountId, setAccountId] = useState<any>(null);
  const [refBorrowRecalls, setRefBorrowRecalls] = useState<any>(null);
  const [refLoans, setRefLoans] = useState<any>(null);
  const [appliedFiltersLoansGrid, setAppliedFiltersLoansGrid] =
    useState<any>(null);
  const [isGridRefresh, setIsGridRefresh] = useState<Boolean>(false);
  const [appliedFiltersBorrowsGrid, setAppliedFiltersBorrowsGrid] =
    useState<any>(null);
  // const [isDataLoaded, setIsDataLoaded] = useState<boolean>(false);
  const [isTotalRowToBeSelected, setIsTotalRowToBeSelected] =
    useState<boolean>(false);
  const [isResetFilters, setIsResetFilters] = useState<boolean>(false);
  const [externalBorrowFilters, setExternalBorrowFilters] = useState<any>(null);
  const [externalLoanFilters, setExternalLoanFilters] = useState<any>(null);
  const socketConsolidate = new SockJS(`${BASE_URI_SOCKET()}`);
  const socketConsolidateClient = Stomp.over(function () {
    return socketConsolidate;
  });
  const [loanRecallCount, setLoanRecallCount] = useState<number>(0);
  const [loanTerminationCount, setLoanTerminationCount] = useState<number>(0);
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState<any>("");
  const [borrowOpenCount, setBorrowOpenCount] = useState<number>(0);
  const [borrowPastDueCount, setBorrowPastDueCount] = useState<number>(0);
  const [borrowPast30dayDueCount, setBorrowPast30dayDueCount] =
    useState<number>(0);
  const [borrowPartialReturnCount, setBorrowPartialReturnCount] =
    useState<number>(0);
  const [borrowFullReturnCount, setBorrowFullReturnCount] = useState<number>(0);
  const [loanOpenCount, setLoanOpenCount] = useState<number>(0);
  const [loanPastDueCount, setLoanPastDueCount] = useState<number>(0);
  const [loanPast30dayDueCount, setLoanPast30dayDueCount] = useState<number>(0);
  const [loanPartialReturnCount, setLoanPartialReturnCount] =
    useState<number>(0);
  const [loanFullReturnCount, setLoanFullReturnCount] = useState<number>(0);
  const [borrowNonOutstandingCount, setBorrowNonOutstandingCount] =
    useState<number>(0);
  const [loanNonOutstandingCount, setLoanNonOutstandingCount] =
    useState<number>(0);
  const [isRecallActivityPopup, setIsRecallActivityPopup] =
    useState<boolean>(false);
  const [lenderRefId, setLenderRefId] = useState<any>(null);
  const [bl, setBL] = useState<any>(null);
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [isContractRecallPopUpOpen, setContractRecallPopupOpen] =
    useState<boolean>(false);
  const [isDeselectAll, setIsDeselectAll] = useState<boolean>(false);
  const [rowsToRecall, setRowsToRecall] = useState<any>([]);
  const [doShowFullScreenLoader, setDoShowFullScreenLoader] =
    useState<boolean>(false);
  const [loanFullRecallCount, setLoanFullRecallCount] = useState<number>(0);
  const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const [isInitialPageLoad, setIsInitialPageLoad] = useState<boolean>(true);
  const [insertedLoanRowIds, setInsertedLoanRowIds] = useState<any>([]);
  const [insertedLoanRows, setInsertedLoanRows] = useState<any>({
    list: [],
    ids: [],
  });
  const [insertedBorrowRows, setInsertedBorrowRows] = useState<any>([]);
  const [insertedBorrowRowIds, setInsertedBorrowRowIds] = useState<any>([]);
  // const t4RecallSocket = new SockJS(`${BASE_URI_CONTRACT_T4_SOCKET()}`);

  // const t4RecallStompClient = Stomp.over(function () {
  //   return t4RecallSocket;
  // });

  // const createConnection = () => {
  //   if (t4RecallStompClient?.state !== ActivationState.ACTIVE) {
  //     establishConnection();
  //   }
  // };

  // function establishConnection() {
  //   t4RecallStompClient.connect(
  //     {},
  //     function (frame: any) {
  //       subscribeT4Recall();
  //     },
  //     {},
  //     () => {}
  //   );
  // }

  // function subscribeT4Recall() {
  //   t4RecallStompClient.subscribe("/topic/t4_recall", function (result: any) {
  //     let resultJson = JSON.parse(result?.body);
  //     console.log("Data received from /topic/t4_recall: ", resultJson);
  //     insertBorrowsAndLoans(resultJson);
  //   });
  // }

  const insertBorrowsAndLoans = (row: Recall) => {
    if (row?.bl === "B") {
      insertBorrows(row);
    } else if (row?.bl === "L") {
      insertLoans(row);
    }
  };

  const insertBorrows = (row: any) => {
    setInitialBorrows((previousRows: any) => {
      if (_.isArray(previousRows)) {
        row.updatetime = getTimeStamp(row.updatetime);
        row.rate = row?.rate ? parseFloat(row?.rate) : row?.rate;
        row.quantity = row.quantity ? parseInt(row.quantity) : 0;
        row.return_qty = row.return_qty ? parseInt(row.return_qty) : 0;
        row.borrow_qty = row.borrow_qty ? parseInt(row.borrow_qty) : 0;
        row.createdDate = getTimeStamp(row.create_date);
        const index = previousRows?.findIndex(
          (x: Recall) => x.recallId === row?.recallId
        );
        if (index >= 0) {
          previousRows[index] = row;
        } else {
          previousRows?.push(row);
        }
      }

      return previousRows;
    });
  };

  const insertLoans = (row: any) => {
    setInitialLoans((previousRows: any) => {
      if (_.isArray(previousRows)) {
        row.updatetime = getTimeStamp(row.updatetime);
        row.rate = row?.rate ? parseFloat(row?.rate) : row?.rate;
        row.quantity = row.quantity ? parseInt(row.quantity) : 0;
        row.return_qty = row.return_qty ? parseInt(row.return_qty) : 0;
        row.loan_qty = row.loan_qty ? parseInt(row.loan_qty) : 0;
        row.createdDate = getTimeStamp(row.create_date);
        const index = previousRows?.findIndex((x: Recall) =>
          x.recallId
            ? x.recallId === row?.recallId
            : x.contract_id === row?.contract_id
        );
        if (index >= 0) {
          previousRows[index] = row;
        } else {
          previousRows?.push(row);
        }
      }
      let sortedRows = _.orderBy(
        previousRows,
        ["isRecall", "sec_id", "rate"],
        ["desc", "asc", "desc"]
      );

      return sortedRows;
    });
  };

  useEffect(() => {
    let activeAccountCode = window.localStorage.getItem("activeAccountCode");
    if (activeAccountCode) {
      setAccountId(activeAccountCode);
    }
  }, []);

  useEffect(() => {
    if (borrows && !_.isEmpty(borrows) && isTotalRowToBeSelected) {
      // setIsDataLoaded(!isDataLoaded);
      setIsTotalRowToBeSelected(false);
    }
  }, [borrows]);

  const getGridsHeight = () => {
    let offsetHeight = document?.getElementById(
      "LoanReturnsTitleDiv"
    )?.offsetHeight;
    if (offsetHeight) offsetHeight = offsetHeight + 10;
    return "calc(100% - " + offsetHeight + "px)";
  };

  useEffect(() => {
    calculateBorrowsCounts(initialBorrows);
  }, [borrows]);

  useEffect(() => {
    calculateLoansCounts(initialLoans);
  }, [loans]);

  const getBorrowsList = async (accId: any) => {
    //setIsBorrowsProcessing(true);
    let borrowRes: any = "";
    let accountId = window.localStorage.getItem("activeAccountCode");
    let request = {
      bl: "B",
      cusip: null,
      accountid: accountId,
    };
    try {
      borrowRes = await getRecallDetails(request);
      if (!borrowRes) {
        setOpen(true);
        setSnackbarMessage(messages.recallsServiceDown);
      } else if (borrowRes?.status === 200) {
        setIsTotalRowToBeSelected(true);
        const borrowResult = await borrowRes.json();

        if (borrowResult?.length > 0) {
          let rows = borrowResult.map((r: any) => ({
            ...r,
            quantity: r.quantity ? parseInt(r.quantity) : 0,
            return_qty: r.return_qty ? parseInt(r.return_qty) : 0,
            borrow_qty: r.borrow_qty ? parseInt(r.borrow_qty) : 0,
            createdDate: getTimeStamp(r.create_date),
            updatedDate: getTimeStamp(r.update_date),
          }));

          setInitialBorrows([...rows]);
        }
      } else if (borrowRes?.status === 401) {
        navigate("/signin");
      } else {
        setBorrows([]);
        setInitialBorrows([]);
        setInitialLoans([]);
        setLoans([]);
      }
    } catch (err) {
      setBorrows([]);
      setInitialBorrows([]);
      setInitialLoans([]);
      setLoans([]);
    } finally {
      setTimeout(() => {
        setIsBorrowsProcessing(false);
        setIsGridRefresh(!isGridRefresh);
      }, 200);
    }
  };

  function onExcelExport() {
    var spreadsheets = [];
    spreadsheets.push(
      refBorrowRecalls?.current?.api?.getSheetDataForExcel?.({
        sheetName: "Borrows",
      })!,
      refLoans?.current?.api?.getSheetDataForExcel?.({
        sheetName: "Loans",
      })!
    );

    exportMultipleSheetsAsExcel({
      data: spreadsheets,
      fileName: "recalls.xlsx",
    });
  }

  const refreshDate = () => {
    setLastRefresh(moment(new Date()).format(constants.RefreshFormat));
  };

  const refreshAccount = () => {
    let accountId = window.localStorage.getItem("activeAccountCode");
    //setIsBorrowsProcessing(true);
    getBorrowsList(accountId);
    getLoansList(accountId, null);
    refreshDate();
  };

  const refreshAccountObj = () => {
    let accountId = window.localStorage.getItem("activeAccountCode");
    setIsLoansProcessing(true);
    setInitialLoans([]);
    setInitialBorrows([]);
    getBorrowsList(accountId);
    getLoansList(accountId, null);
    refreshDate();
  };

  const onFilterTextChange = (event: any) => {
    debounceGlobalSearch(event.target.value, setGlobalSearch);
  };

  const getLoansList = async (accId: any, cusip: any) => {
    let loansRes: any = "";
    let request = {
      bl: "L",
      cusip: cusip,
      accountid: accId,
    };

    try {
      loansRes = await getRecallDetailsAndOutstandingLoans(request);
      if (!loansRes) {
        setOpen(true);
        setSnackbarMessage(messages.recallsServiceDown);
      } else if (loansRes?.status === 200) {
        let rows: any[] = [];
        const loansResult = await loansRes.json();
        if (loansResult?.length > 0) {
          rows = loansResult.map((r: any) => ({
            ...r,
            id: `${r?.contract_id}_${r?.recallId || "0"}`,
            quantity: r.quantity ? parseInt(r.quantity) : 0,
            return_qty: r.return_qty ? parseInt(r.return_qty) : 0,
            sod_loan_qty: r.sod_loan_qty ? parseInt(r.sod_loan_qty) : 0,
            loan_qty: r.loan_qty ? parseInt(r.loan_qty) : 0,
            rate: r.rate ? parseFloat(r.rate) : r.rate,
            updatedDate: getTimeStamp(r.update_date),
            createdDate: getTimeStamp(r.create_date),
          }));

          // const groupedRows = _.groupBy(rows, "contract_id");
          // const finalList: any[] = [];
          // _.forIn(groupedRows, (value: any, key: any) => {
          //   if (_.isArray(value) && value?.length > 0) {
          //     const recalledQuantity = _.sumBy(value, "quantity");
          //     const loan_qty = value[0]?.loan_qty;
          //     const list = value?.map((contract: any) => {
          //       return {
          //         ...contract,
          //         isFullRecall: recalledQuantity >= loan_qty,
          //       };
          //     });

          //     if (_.isArray(list) && list?.length > 0) {
          //       finalList.push(...list);
          //     }
          //   }
          // });

          let selectedLoanList = [...rows];
          setSelectedCusip((prevVal: any) => {
            if (prevVal) {
              selectedLoanList = rows?.filter((a: any) => a.sec_id === prevVal);
            }
            let sortedLoans = _.orderBy(
              selectedLoanList,
              ["updatedDate","isRecall", "sec_id", "rate"],
              ["desc", "asc", "desc"]
            );

            setInitialLoans([...sortedLoans]);

            return prevVal;
          });
        } else {
          setInitialLoans([]);
        }
      } else if (loansRes?.status === 401) {
        setIsLoansProcessing(false);
        navigate("/signin");
      } else {
        setInitialLoans([]);
      }
    } catch (err) {
      setInitialLoans([]);
    } finally {
      setIsLoansProcessing(false);
    }
  };

  const reset = () => {
    setIsLoansProcessing(true);
    setIsResetFilters(!isResetFilters);
    setSelectedTicker(null);
    setSelectedTickerCusip(null)
    _.isNull(selectedCusip) ? setCusipLoans(null) : setSelectedCusip(null);
  };

  const calculateBorrowsCounts = (rows: any) => {
    const openRowsCount = rows?.filter(
      (x: Recall) =>
        x.quantity > x.return_qty && x.status !== "X" && x.status !== "D"
    );
    setBorrowOpenCount(openRowsCount?.length);
    const now = moment();
    const pastDue = rows?.filter(
      (x: Recall) => now.isAfter(x.buyin_date, "day") === true
    );
    setBorrowPastDueCount(pastDue?.length);

    const past30Days = moment().add(-30, "days");
    const past30DayDue = rows?.filter(
      (x: Recall) => past30Days.isAfter(x.buyin_date, "day") === true
    );
    setBorrowPast30dayDueCount(past30DayDue?.length);

    const partialReturnRows = rows?.filter((x: Recall) => x.status === "P");
    setBorrowPartialReturnCount(partialReturnRows?.length);

    const fullReturnRows = rows?.filter((x: Recall) => x.status === "F");
    setBorrowFullReturnCount(fullReturnRows?.length);

    const nonOutStandingRows = rows?.filter(
      (x: Recall) =>
        !_.isEmpty(x.activity_type) && x.activity_type !== "Outstanding"
    );
    setBorrowNonOutstandingCount(nonOutStandingRows?.length);
  };

  const calculateLoansCounts = (rows: any) => {
    const recallCount = rows?.filter((x: Recall) => x.isRecall === "Y");
    setLoanRecallCount(recallCount?.length);
    const openRowsCount = rows?.filter(
      (x: Recall) =>
        x.quantity > x.return_qty && x.status !== "X" && x.status !== "D"
    );
    setLoanOpenCount(openRowsCount?.length);
    const now = moment();
    const pastDue = rows?.filter(
      (x: Recall) => now.isAfter(x.buyin_date, "day") === true
    );
    setLoanPastDueCount(pastDue?.length);

    const past30Days = moment().add(-30, "days");
    const past30DayDue = rows?.filter(
      (x: Recall) => past30Days.isAfter(x.buyin_date, "day") === true
    );
    setLoanPast30dayDueCount(past30DayDue?.length);

    const partialReturnRows = rows?.filter((x: Recall) => x.status === "P");
    setLoanPartialReturnCount(partialReturnRows?.length);

    const fullReturnRows = rows?.filter((x: Recall) => x.status === "F");
    setLoanFullReturnCount(fullReturnRows?.length);

    const nonOutStandingRows = rows?.filter(
      (x: Recall) =>
        !_.isEmpty(x.activity_type) &&
        x.activity_type !== "Outstanding" &&
        x.isRecall === "Y"
    );
    setLoanNonOutstandingCount(nonOutStandingRows?.length);
    const fullRecallRows = rows?.filter((x: Recall) => !x.isFullyRecalled);
    setLoanFullRecallCount(fullRecallRows?.length);
  };

  const setCusipLoans = async (cusip: any) => {
    let accountId = window.localStorage.getItem("activeAccountCode");
    setInitialLoans([]);
    await getLoansList(accountId, cusip);
  };

  useEffect(() => {
    if (!isInitialPageLoad) {
      if (!_.isNull(selectedCusip)) {
        setCusipLoans(selectedCusip);
        let row = initialBorrows?.find(
          (l: Recall) => l?.sec_id === selectedCusip
        );
        row?.ticker ? setSelectedTicker(row?.ticker) : setSelectedTicker(null);
        row?.sec_id ? setSelectedTickerCusip(row?.sec_id) : setSelectedTicker(null);
        
      } else {
        setCusipLoans(null);
      }
    }
  }, [selectedCusip]);

  useEffect(() => {
    if (isInitialPageLoad) {
      setIsInitialPageLoad(false);
    }
    
    getServiceHealthCheck()
  
  }, []);

  useEffect(() => {
    let rows = [...initialBorrows];
    if (externalBorrowFilters && !_.isEmpty(rows)) {
      if (!_.isEmpty(initialBorrows)) {
        if (
          externalBorrowFilters.isPastDueFilterActive ||
          externalBorrowFilters.isPast30dayDueFilterActive
        ) {
          if (externalBorrowFilters.isPastDueFilterActive) {
            rows = filterBorrowRows(recallMetricFilters.pastDue, rows);
          } else if (externalBorrowFilters.isPast30dayDueFilterActive) {
            rows = filterBorrowRows(recallMetricFilters.past30dayDue, rows);
          }
        }

        if (
          externalBorrowFilters.isPartialReturnFilterActive ||
          externalBorrowFilters.isFullReturnFilterActive
        ) {
          if (externalBorrowFilters.isPartialReturnFilterActive) {
            rows = filterBorrowRows(recallMetricFilters.partialReturn, rows);
          } else if (externalBorrowFilters.isFullReturnFilterActive) {
            rows = filterBorrowRows(recallMetricFilters.fullReturn, rows);
          }
        }

        if (externalBorrowFilters.isOpenFilterActive) {
          rows = filterBorrowRows(recallMetricFilters.open, rows);
        }

        if (externalBorrowFilters.isNonOutstandingFilterActive) {
          rows = filterBorrowRows(recallMetricFilters.nonOutStanding, rows);
        }
      }
    }
    setBorrows(rows);
  }, [externalBorrowFilters, initialBorrows]);

  useEffect(() => {
    let rows = [...initialLoans];
    if (externalLoanFilters && !_.isEmpty(rows)) {
      if (externalLoanFilters.isRecallFilterActive) {
        rows = filterLoanRows(recallMetricFilters.recall, rows);
      }
      if (
        externalLoanFilters.isPastDueFilterActive ||
        externalLoanFilters.isPast30dayDueFilterActive
      ) {
        if (externalLoanFilters.isPastDueFilterActive) {
          rows = filterLoanRows(recallMetricFilters.pastDue, rows);
        } else if (externalLoanFilters.isPast30dayDueFilterActive) {
          rows = filterLoanRows(recallMetricFilters.past30dayDue, rows);
        }
      }

      if (
        externalLoanFilters.isPartialReturnFilterActive ||
        externalLoanFilters.isFullReturnFilterActive
      ) {
        if (externalLoanFilters.isPartialReturnFilterActive) {
          rows = filterLoanRows(recallMetricFilters.partialReturn, rows);
        } else if (externalLoanFilters.isFullReturnFilterActive) {
          rows = filterLoanRows(recallMetricFilters.fullReturn, rows);
        }
      }

      if (externalLoanFilters.isOpenFilterActive) {
        rows = filterLoanRows(recallMetricFilters.open, rows);
      }

      if (externalLoanFilters.isNonOutstandingFilterActive) {
        rows = filterLoanRows(recallMetricFilters.nonOutStanding, rows);
      }

      if (externalLoanFilters.isFullRecallFilterActive) {
        rows = filterLoanRows(recallMetricFilters.fullRecall, rows);
      }
    }
     let sortedRows = _.orderBy(
          rows,
          ["updatedDate","isRecall", "sec_id", "rate"],
          ["desc", "asc", "desc"]
        );
    setLoans(sortedRows);
  }, [externalLoanFilters, initialLoans]);

  const filterBorrowRows = (filter: any, rows: any) => {
    switch (filter) {
      case recallMetricFilters.open:
        return rows?.filter(
          (x: Recall) =>
            x.quantity > x.return_qty && x.status !== "X" && x.status !== "D"
        );
      case recallMetricFilters.pastDue:
        let now = moment();
        return rows?.filter(
          (x: Recall) => now.isAfter(x.buyin_date, "day") === true
        );
      case recallMetricFilters.past30dayDue:
        let past30Days = moment().add(-30, "days");
        return rows?.filter(
          (x: Recall) => past30Days.isAfter(x.buyin_date, "day") === true
        );
      case recallMetricFilters.partialReturn:
        return rows?.filter((x: Recall) => x.status === "P");
      case recallMetricFilters.fullReturn:
        return rows?.filter((x: Recall) => x.status === "F");
      case recallMetricFilters.nonOutStanding:
        return rows?.filter(
          (x: Recall) =>
            !_.isEmpty(x.activity_type) && x.activity_type !== "Outstanding"
        );
    }
    return rows;
  };

  const filterLoanRows = (filter: any, rows: any) => {
    switch (filter) {
      case recallMetricFilters.recall:
        return rows?.filter((x: Recall) => x.isRecall === "Y");
      case recallMetricFilters.open:
        return rows?.filter(
          (x: Recall) =>
            x.quantity > x.return_qty && x.status !== "X" && x.status !== "D"
        );
      case recallMetricFilters.pastDue:
        let now = moment();
        return rows?.filter(
          (x: Recall) => now.isAfter(x.buyin_date, "day") === true
        );
      case recallMetricFilters.past30dayDue:
        let past30Days = moment().add(-30, "days");
        return rows?.filter(
          (x: Recall) => past30Days.isAfter(x.buyin_date, "day") === true
        );
      case recallMetricFilters.partialReturn:
        return rows?.filter((x: Recall) => x.status === "P");
      case recallMetricFilters.fullReturn:
        return rows?.filter((x: Recall) => x.status === "F");
      case recallMetricFilters.nonOutStanding:
        return rows?.filter(
          (x: Recall) =>
            !_.isEmpty(x.activity_type) &&
            x.activity_type !== "Outstanding" &&
            x.isRecall === "Y"
        );
      case recallMetricFilters.fullRecall:
        return rows?.filter((x: Recall) => !x.isFullyRecalled);
    }
    return rows;
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === constants.clickaway) {
      return;
    }

    setOpen(false);
  };

  const getContextMenuItems = (params: any) => {
    var rightClickOptionsROnlyAccess = [
      {
        name: "Recall Activity",
        action: () => {
          onOpenRecallActivity(
            params?.node?.aggData ? params?.node?.aggData : params?.node?.data
          );
        },
      },
      "copy",
      "copyWithHeaders",
      "copyWithGroupHeaders",
      "paste",
      "export",
    ];
    return params?.node?.data || params?.node?.aggData
      ? rightClickOptionsROnlyAccess
      : [];
  };

  const onOpenRecallActivity = (data: Recall) => {
    setLenderRefId(data.lender_ref_id);
    setBL(data.bl);
  };

  useEffect(() => {
    if (lenderRefId && bl && !_.isEmpty(lenderRefId) && !_.isEmpty(bl)) {
      setIsRecallActivityPopup(true);
    }
  }, [lenderRefId, bl]);

  const onRecallActivityClose = () => {
    setIsRecallActivityPopup(false);
    setLenderRefId(null);
    setBL(null);
  };

  const onRecallClick = () => {
    setContractRecallPopupOpen(true);
  };

  const handleContractRecallClose = () => {
    setSelectedRows([]);
    setIsDeselectAll(true);
    setTimeout(() => {
      setIsDeselectAll(false);
    }, 500);
    setContractRecallPopupOpen(false);
 getLoansList(accountId, null);
    // setTimeout(() => {
    //    getLoansList(accountId, null);
    // }, 800);
  };

  useEffect(() => {
    if (selectedRows && _.isArray(selectedRows) && selectedRows?.length > 0) {
      let rows = selectedRows?.map((row: any) => {
        return {
          ...row,
          quantity: row?.sod_quantity ===0? parseInt(row?.loan_qty):+row?.sod_quantity,
          contract_type: row?.bl,
          cusip: row?.sec_id,
          id: row.contract_id,
        };
      });

      setRowsToRecall(rows);
    } else {
      setRowsToRecall([]);
    }
  }, [selectedRows]);

  const getCardHeight = () => {
    const offsetHeight = document?.getElementById("rates-title")?.offsetHeight;
    const divHeight = _.isUndefined(offsetHeight) ? 2 : offsetHeight + 2;

    return "calc(100% - " + divHeight + "px)";
  };

  // useEffect(() => {
  //   const returnInterval: any = setInterval(() => {
  //     refreshAccount();
  //   }, 5000);
  //   return () => clearInterval(returnInterval);
  // }, []);

  useEffect(() => {
    socketConsolidateClient.connect(
      {},
      function (frame: any) {
        socketConsolidateClient.subscribe(
          "/topic/consolidated_message",
          async function (result: any) {
            let resultJson = JSON.parse(result?.body);
            if(getEnv() !== envs.PROD){
              console.log(`Data received from /topic/consolidated_message at ${moment()?.toDate()} - `,resultJson);
            }
            
            await onSocketMsgReceive(resultJson?.socketMssgmap);
          }
        );
      },
      {},
      () => {}
    );

    return () => {
      if (socketConsolidateClient?.connected) {
        socketConsolidateClient?.unsubscribe("/topic/consolidated_message");
        socketConsolidateClient?.disconnect();
      }
    };
  }, []);

  // const onSocketMsgReceive = async (msg: any) => {
  //   const contractList = _.get(msg, socketMsgType.CONTRACT_UPDATES_RECALL);
  //   const dtcStatusList = _.get(msg, socketMsgType.MATCH_CONTRACT_ACTIVITY);
  //   const recallList = _.get(msg, socketMsgType.RECALL);

  //   if (_.isArray(recallList) && !_.isEmpty(recallList)) {
  //     let socketRows = [...recallList]?.map((item: any) => {
  //       let con = item?.messageJson;
  //       return {
  //         ...con,
  //         id: con?.recallId > 0 ? con?.recallId : con?.contract_id,
  //         quantity: con.quantity ? parseInt(con.quantity) : 0,
  //         return_qty: con.return_qty ? parseInt(con.return_qty) : 0,
  //         borrow_qty: con.borrow_qty ? parseInt(con.borrow_qty) : 0,
  //         createdDate: getTimeStamp(con.create_date),
  //         updatedDate: getTimeStamp(con.update_date),
  //         sod_loan_qty: con.sod_loan_qty ? parseInt(con.sod_loan_qty) : 0,
  //         loan_qty: con.loan_qty ? parseInt(con.loan_qty) : 0,
  //         rate: con.rate ? parseFloat(con.rate) : con.rate,
  //       };
  //     });

  //     const borrowRows = [...socketRows]?.filter((c: any) => c?.bl === "B");

  //     const loanRows = [...socketRows]?.filter((c: any) => c?.bl === "L");

  //     if (_.isArray(loanRows) && !_.isEmpty(loanRows)) {
  //       setLoans((previousRows: any) => {
  //         const currentRows = previousRows;
  //         const insertRows: any[] = [];

  //         loanRows?.forEach((loan) => {
  //           var index = currentRows?.findIndex(
  //             (l: any) => l?.isRecall === "Y" && l?.recallId === loan?.recallId
  //           );
  //           var updateIndex = currentRows?.findIndex(
  //             (l: any) =>
  //               l?.contract_id === loan?.contract_id && l?.isRecall === "N"
  //           );
  //           if (index >= 0 || updateIndex >= 0) {
  //             const ind = index >= 0 ? index : updateIndex;
  //             currentRows[ind] = loan;
  //           } else {
  //             insertRows?.push({
  //               ...loan,
  //               id: loan?.recallId > 0 ? loan?.recallId : loan?.contract_id,
  //             });
  //           }
  //         });

  //         let sortedRows = _.orderBy(
  //           currentRows,
  //           ["isRecall", "sec_id", "rate"],
  //           ["desc", "asc", "desc"]
  //         );
  //         if (insertRows && _.isArray(insertRows) && insertRows?.length > 0) {
  //           const ids = insertRows?.map((c) => {
  //             return c?.id;
  //           });
  //           setInsertedLoanRowIds(ids?.length > 0 ? [ids] : []);
  //           const uniqRows = _.uniqBy(insertRows, "id");
  //           setInsertedLoanRows({ list: [...uniqRows], ids: [...ids] });
  //         }

  //         return sortedRows;
  //       });

  //       setInitialLoans((previousRows: any) => {
  //         const currentRows = previousRows;

  //         loanRows?.forEach((loan) => {
  //           var index = currentRows?.findIndex(
  //             (l: any) => l?.isRecall === "Y" && l?.recallId === loan?.recallId
  //           );
  //           var updateIndex = currentRows?.findIndex(
  //             (l: any) =>
  //               l?.contract_id === loan?.contract_id && l?.isRecall === "N"
  //           );
  //           if (index >= 0 || updateIndex >= 0) {
  //             const ind = index >= 0 ? index : updateIndex;
  //             currentRows[ind] = loan;
  //           }
  //         });

  //         let sortedRows = _.orderBy(
  //           currentRows,
  //           ["isRecall", "sec_id", "rate"],
  //           ["desc", "asc", "desc"]
  //         );

  //         return sortedRows;
  //       });
  //     }

  //     if (_.isArray(borrowRows) && !_.isEmpty(borrowRows)) {
  //       setBorrows((previousRows: any) => {
  //         const currentRows = previousRows;
  //         const insertRows: any[] = [];
  //         borrowRows?.forEach((loan) => {
  //           var index = currentRows?.findIndex(
  //             (l: any) => l?.recallId === loan?.recallId
  //           );
  //           if (index >= 0) {
  //             currentRows[index] = loan;
  //           }
  //         });
  //         if (insertRows && _.isArray(insertRows) && insertRows?.length > 0) {
  //           const ids = insertRows?.map((c) => {
  //             return c?.id;
  //           });
  //           setInsertedBorrowRowIds(ids?.length > 0 ? [ids] : []);
  //         }
  //         const uniqRows = _.uniqBy(insertRows, "id");
  //         setInsertedBorrowRows(uniqRows);

  //         return currentRows;
  //       });

  //       setInitialBorrows((previousRows: any) => {
  //         const currentRows = previousRows;

  //         borrowRows?.forEach((loan) => {
  //           var index = currentRows?.findIndex(
  //             (l: any) => l?.recallId === loan?.recallId
  //           );
  //           if (index >= 0) {
  //             currentRows[index] = loan;
  //           }
  //         });

  //         return currentRows;
  //       });
  //     }
  //   }
  //   if (_.isArray(contractList) && !_.isEmpty(contractList)) {
  //     let socketRows = [...contractList]?.map((item: any) => {
  //       let con = item?.messageJson;
  //       return {
  //         ...con,
  //         id: con?.recallId > 0 ? con?.recallId : con?.contract_id,
  //         quantity: con.quantity ? parseInt(con.quantity) : 0,
  //         return_qty: con.return_qty ? parseInt(con.return_qty) : 0,
  //         borrow_qty: con.borrow_qty ? parseInt(con.borrow_qty) : 0,
  //         createdDate: getTimeStamp(con.create_date),
  //         updatedDate: getTimeStamp(con.update_date),
  //         sod_loan_qty: con.sod_loan_qty ? parseInt(con.sod_loan_qty) : 0,
  //         loan_qty: con.loan_qty ? parseInt(con.loan_qty) : 0,
  //         rate: con.rate ? parseFloat(con.rate) : con.rate,
  //       };
  //     });

  //     const borrowRows = [...socketRows]?.filter((c: any) => c?.bl === "B");

  //     const loanRows = [...socketRows]?.filter((c: any) => c?.bl === "L");

  //     if (_.isArray(loanRows) && !_.isEmpty(loanRows)) {
  //       setLoans((previousRows: any) => {
  //         const currentRows = previousRows;
  //         const insertRows: any[] = [];
  //         loanRows?.forEach((loan) => {
  //           var index = currentRows?.findIndex(
  //             (l: any) => l?.isRecall === "Y" && l?.recallId === loan?.recallId
  //           );
  //           var updateIndex = currentRows?.findIndex(
  //             (l: any) =>
  //               l?.contract_id === loan?.contract_id && l?.isRecall === "N"
  //           );
  //           if (index >= 0 || updateIndex >= 0) {
  //             const ind = index >= 0 ? index : updateIndex;
  //             currentRows[ind] = loan;
  //           } else {
  //             insertRows?.push({ ...loan });
  //           }
  //         });

  //         let sortedRows = _.orderBy(
  //           currentRows,
  //           ["isRecall", "sec_id", "rate"],
  //           ["desc", "asc", "desc"]
  //         );
  //         if (insertRows && _.isArray(insertRows) && insertRows?.length > 0) {
  //           const ids = insertRows?.map((c) => {
  //             return c?.id;
  //           });
  //           setInsertedLoanRowIds(ids?.length > 0 ? [ids] : []);
  //           const uniqRows = _.uniqBy(insertRows, "id");
  //           setInsertedLoanRows({ list: [...uniqRows], id: [...ids] });
  //         }

  //         return sortedRows;
  //       });

  //       setInitialLoans((previousRows: any) => {
  //         const currentRows = previousRows;

  //         loanRows?.forEach((loan) => {
  //           var index = currentRows?.findIndex(
  //             (l: any) => l?.isRecall === "Y" && l?.recallId === loan?.recallId
  //           );
  //           var updateIndex = currentRows?.findIndex(
  //             (l: any) =>
  //               l?.contract_id === loan?.contract_id && l?.isRecall === "N"
  //           );
  //           if (index >= 0 || updateIndex >= 0) {
  //             const ind = index >= 0 ? index : updateIndex;
  //             currentRows[ind] = loan;
  //           }
  //         });

  //         let sortedRows = _.orderBy(
  //           currentRows,
  //           ["isRecall", "sec_id", "rate"],
  //           ["desc", "asc", "desc"]
  //         );

  //         return sortedRows;
  //       });
  //     }

  //     if (_.isArray(borrowRows) && !_.isEmpty(borrowRows)) {
  //       setBorrows((previousRows: any) => {
  //         const currentRows = previousRows;
  //         const insertRows: any[] = [];
  //         borrowRows?.forEach((loan) => {
  //           var index = currentRows?.findIndex(
  //             (l: any) => l?.recallId === loan?.recallId
  //           );
  //           if (index >= 0) {
  //             currentRows[index] = loan;
  //           }
  //         });
  //         if (insertRows && _.isArray(insertRows) && insertRows?.length > 0) {
  //           const ids = insertRows?.map((c) => {
  //             return c?.id;
  //           });
  //           setInsertedBorrowRowIds(ids?.length > 0 ? [ids] : []);
  //         }
  //         const uniqRows = _.uniqBy(insertRows, "id");
  //         setInsertedBorrowRows(uniqRows);

  //         return currentRows;
  //       });

  //       setInitialBorrows((previousRows: any) => {
  //         const currentRows = previousRows;

  //         borrowRows?.forEach((loan) => {
  //           var index = currentRows?.findIndex(
  //             (l: any) => l?.recallId === loan?.recallId
  //           );
  //           if (index >= 0) {
  //             currentRows[index] = loan;
  //           }
  //         });

  //         return currentRows;
  //       });
  //     }
  //   }
  //   if (_.isArray(dtcStatusList) && !_.isEmpty(dtcStatusList)) {
  //     let socketRows = [...dtcStatusList]?.map((item: any) => {
  //       return {
  //         ...item,
  //         id: item?.recallId > 0 ? item?.recallId : item?.contract_id,
  //       };
  //     });

  //     const lRows = socketRows?.filter((c: any) => c?.bl === "L");
  //     if (lRows) {
  //       await updateDTCStatusLoanGrid(lRows);
  //     }
  //   }
  // };


const onSocketMsgReceive = async (msg: any) => {
  const contractList = _.get(msg, socketMsgType.CONTRACT_UPDATES_RECALL);
  const dtcStatusList = _.get(msg, socketMsgType.MATCH_CONTRACT_ACTIVITY);
  const recallList = _.get(msg, socketMsgType.RECALL);

  if (_.isArray(recallList) && !_.isEmpty(recallList)) {
    const socketRows = recallList.map((item: any) => {
      const con = item?.messageJson;
      return {
        ...con,
        id: `${con?.contract_id}_${con?.recallId || "0"}`,
        quantity: con.quantity ? parseInt(con.quantity) : 0,
        return_qty: con.return_qty ? parseInt(con.return_qty) : 0,
        borrow_qty: con.borrow_qty ? parseInt(con.borrow_qty) : 0,
        createdDate: getTimeStamp(con.create_date),
        updatedDate: getTimeStamp(con.update_date),
        sod_loan_qty: con.sod_loan_qty ? parseInt(con.sod_loan_qty) : 0,
        loan_qty: con.loan_qty ? parseInt(con.loan_qty) : 0,
        rate: con.rate ? parseFloat(con.rate) : con.rate,
      };
    });

    const borrowRows = socketRows.filter((c: any) => c?.bl === "B");
    const loanRows = socketRows.filter((c: any) => c?.bl === "L");

    if (_.isArray(loanRows) && !_.isEmpty(loanRows)) {
      setLoans((previousRows: any) => {
        const currentRows = [...previousRows];
        const insertRows: any[] = [];

        loanRows.forEach((loan) => {
          const index = currentRows.findIndex(
            (l: any) => l?.recallId === loan?.recallId
          );
          const updateIndex = currentRows.findIndex(
            (l: any) => l?.contract_id === loan?.contract_id && l?.isRecall === "N"
          );

          if (index >= 0 || updateIndex>=0) {
            const ind =index>=0? index: updateIndex;
            currentRows[ind] = loan;
          } else {
            insertRows.push({ ...loan, id: `${loan?.contract_id}_${loan?.recallId || "0"}` });
          }
        });

        const uniqInsertRows = _.uniqBy(insertRows, "id");

        const sortedRows = _.orderBy(
          currentRows.concat(uniqInsertRows),
          ["updatedDate"],
          ["desc"]
        );

        if (uniqInsertRows.length > 0) {
          const ids = uniqInsertRows.map((c) => c.id);
          setInsertedLoanRowIds(ids.length > 0 ? [ids] : []);
          setInsertedLoanRows({ list: [...uniqInsertRows], ids: [...ids] });
        }
       
        return sortedRows;
      });

      setInitialLoans((previousRows: any) => {
        const currentRows = [...previousRows];
        loanRows.forEach((loan) => {
          const index = currentRows.findIndex(
            (l: any) => l?.recallId === loan?.recallId
          );
          const updateIndex = currentRows.findIndex(
            (l: any) => l?.contract_id === loan?.contract_id && l?.isRecall === "N"
          );

          if (index >= 0 || updateIndex>=0) {
            const ind =index>=0? index: updateIndex;
            currentRows[ind] = loan;
          }

        });

        const sortedRows = _.orderBy(currentRows, ["updatedDate"],["desc"]);
         return sortedRows;
      });
    }

    if (_.isArray(borrowRows) && !_.isEmpty(borrowRows)) {
      setBorrows((previousRows: any) => {
        const currentRows = [...previousRows];
        const insertRows: any[] = [];

        borrowRows.forEach((borrow) => {
          const index = currentRows.findIndex((l: any) => l?.recallId === borrow?.recallId);
          if (index >= 0) {
            currentRows[index] = borrow;
          } else {
            insertRows.push({ ...borrow });
          }
        });

        const uniqInsertRows = _.uniqBy(insertRows, "id");
        if (uniqInsertRows.length > 0) {
          const ids = uniqInsertRows.map((c) => c.id);
          setInsertedBorrowRowIds(ids.length > 0 ? [ids] : []);
        }
        setInsertedBorrowRows(uniqInsertRows);

        return currentRows.concat(uniqInsertRows);
      });

      setInitialBorrows((previousRows: any) => {
        const currentRows = [...previousRows];
        borrowRows.forEach((borrow) => {
          const index = currentRows.findIndex((l: any) => l?.recallId === borrow?.recallId);
          if (index >= 0) currentRows[index] = borrow;
        });
        return currentRows;
      });
    }
  }

    if (_.isArray(contractList) && !_.isEmpty(contractList)) {
      let socketRows = [...contractList]?.map((item: any) => {
        let con = item?.messageJson;
        return {
          ...con,
          id: `${con?.contract_id}_${con?.recallId || "0"}`,
          quantity: con.quantity ? parseInt(con.quantity) : 0,
          return_qty: con.return_qty ? parseInt(con.return_qty) : 0,
          borrow_qty: con.borrow_qty ? parseInt(con.borrow_qty) : 0,
          createdDate: getTimeStamp(con.create_date),
          updatedDate: getTimeStamp(con.update_date),
          sod_loan_qty: con.sod_loan_qty ? parseInt(con.sod_loan_qty) : 0,
          loan_qty: con.loan_qty ? parseInt(con.loan_qty) : 0,
          rate: con.rate ? parseFloat(con.rate) : con.rate,
        };
      });

      const borrowRows = [...socketRows]?.filter((c: any) => c?.bl === "B");

      const loanRows = [...socketRows]?.filter((c: any) => c?.bl === "L");

      if (_.isArray(loanRows) && !_.isEmpty(loanRows)) {
        setLoans((previousRows: any) => {
          const currentRows = previousRows;
          // const insertRows: any[] = [];
          loanRows?.forEach((loan) => {
             var index = currentRows?.findIndex(
              (l: any) => l?.recallId === loan?.recallId
            );
            
            if (index >= 0 ) {
              const ind = index;
              currentRows[ind] = loan;
            }
            // var index = currentRows?.findIndex(
            //   (l: any) => l?.isRecall === "Y" && l?.recallId === loan?.recallId
            // );
            // var updateIndex = currentRows?.findIndex(
            //   (l: any) =>
            //     l?.contract_id === loan?.contract_id && l?.isRecall === "N"
            // );
            // if (index >= 0 || updateIndex >= 0) {
            //   const ind = index >= 0 ? index : updateIndex;
            //   currentRows[ind] = loan;
            // }
            //  else {
            //   insertRows?.push({ ...loan });
            // }
          });

          let sortedRows = _.orderBy(
            currentRows,
            ["updatedDate"],
            ["desc"]
          );
          // if (insertRows && _.isArray(insertRows) && insertRows?.length > 0) {
          //   const ids = insertRows?.map((c) => {
          //     return c?.id;
          //   });
          //   setInsertedLoanRowIds(ids?.length > 0 ? [ids] : []);
          //   const uniqRows = _.uniqBy(insertRows, "id");
          //   setInsertedLoanRows({ list: [...uniqRows], id: [...ids] });
          // }

          return sortedRows;
        });

        setInitialLoans((previousRows: any) => {
          const currentRows = previousRows;

          loanRows?.forEach((loan) => {
             var index = currentRows?.findIndex(
              (l: any) => l?.recallId === loan?.recallId
            );
            
            if (index >= 0 ) {
              const ind = index;
              currentRows[ind] = loan;
            }
            // var index = currentRows?.findIndex(
            //   (l: any) => l?.isRecall === "Y" && l?.recallId === loan?.recallId
            // );
            // var updateIndex = currentRows?.findIndex(
            //   (l: any) =>
            //     l?.contract_id === loan?.contract_id && l?.isRecall === "N"
            // );
            // if (index >= 0 || updateIndex >= 0) {
            //   const ind = index >= 0 ? index : updateIndex;
            //   currentRows[ind] = loan;
            // }
          });

          let sortedRows = _.orderBy(
            currentRows,
            ["updatedDate"],
            ["desc"]
          );

          return sortedRows;
        });
      }

      if (_.isArray(borrowRows) && !_.isEmpty(borrowRows)) {
        setBorrows((previousRows: any) => {
          const currentRows = previousRows;
          const insertRows: any[] = [];
          borrowRows?.forEach((loan) => {
            var index = currentRows?.findIndex(
              (l: any) => l?.recallId === loan?.recallId
            );
            if (index >= 0) {
              currentRows[index] = {...loan};
            }
          });
          if (insertRows && _.isArray(insertRows) && insertRows?.length > 0) {
            const ids = insertRows?.map((c) => {
              return c?.id;
            });
            setInsertedBorrowRowIds(ids?.length > 0 ? [ids] : []);
          }
          const uniqRows = _.uniqBy(insertRows, "id");
          setInsertedBorrowRows(uniqRows);

          return [...currentRows];
        });

        setInitialBorrows((previousRows: any) => {
          const currentRows = previousRows;

          borrowRows?.forEach((loan) => {
            var index = currentRows?.findIndex(
              (l: any) => l?.recallId === loan?.recallId
            );
            if (index >= 0) {
              currentRows[index] = {...loan};
            }
          });

          return [...currentRows];
        });
      }
    }
    if (_.isArray(dtcStatusList) && !_.isEmpty(dtcStatusList)) {
    const socketRows = dtcStatusList.map((item: any) => ({
      ...item,
      id: item?.recallId > 0 ? item?.recallId : item?.contract_id,
    }));

    const lRows = socketRows.filter((c: any) => c?.bl === "L");
    if (lRows.length > 0) {
      await updateDTCStatusLoanGrid(lRows);
    }
  }
};



  useEffect(() => {
    const insertedLoanList = insertedLoanRows?.list;
    if (
      [...insertedLoanList]?.length > 0 &&
      _.isArray([...insertedLoanList]) &&
      !_.isEmpty([...insertedLoanList])
    ) {
      // setLoans((previousRows: any) => {
      //   const rows = [...insertedLoanList, ...previousRows];
      //   let sortedRows = _.orderBy(
      //     rows,
      //     ["updatedDate"],
      //     ["desc"]
      //   );

      //   return sortedRows;
      // });

      setInitialLoans((previousRows: any) => {
        const rows = [...insertedLoanList, ...previousRows];
        let sortedRows = _.orderBy(
          rows,
          ["updatedDate"],
          ["desc"]
        );

        return sortedRows;
      });
    }
  }, [insertedLoanRows]);

  useEffect(() => {
    if (
      insertedBorrowRows &&
      _.isArray(insertedBorrowRows) &&
      !_.isEmpty(insertedBorrowRows)
    ) {
      setBorrows((previousRows: any) => {
        const rows = [...insertedBorrowRows, ...previousRows];

        return rows;
      });

      setInitialBorrows((previousRows: any) => {
        const rows = [...insertedBorrowRows, ...previousRows];

        return rows;
      });
    }
  }, [insertedBorrowRows]);

  const updateDTCStatusLoanGrid = async (trades: any) => {
    setLoans((previousRows: any) => {
      if (_.isArray(previousRows)) {
        let currentRows = [...previousRows];
        if (_.isArray(trades)) {
          trades?.forEach((trade: any) => {
            let index = currentRows?.findIndex(
              (b: any) => b?.recallId === trade?.recallId
            );
            if (index >= 0) {
              currentRows[index].dtc_status = trade?.dtc_status;
              return currentRows;
            }
          });
        }
      }

      return previousRows;
    });

    setInitialLoans((previousRows: any) => {
      if (_.isArray(previousRows)) {
        let currentRows = [...previousRows];
        if (_.isArray(trades)) {
          trades?.forEach((trade: any) => {
            let index = currentRows?.findIndex(
              (b: any) => b?.recallId === trade?.recallId
            );
            if (index >= 0) {
              currentRows[index].return_dtc_status = trade?.return_dtc_status;
              return currentRows;
            }
          });
        }
      }

      return previousRows;
    });
  };

  const getServiceHealthCheck = async () => {
    await isServiceHealthy(
      `${serviceAPIMapping["RECALL-SERVICE"].apiRouteURL}/${EndPoint.actuator}`
    ).then((response: any) => {
      if (!response?.ok || response?.status === 503) {
        setSnackbarMessage(`${messages.recallsServiceDown}`);
        setOpen(true);
      } else {
        refreshAccount();
      }
    });
  };

  return (
    <>
      <Snackbar open={open} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="error"
          sx={{
            width: "100%",
            backgroundColor: "orange",
            textDecorationColor: "white",
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <div
        style={{
          height: "100%",
          width: "100%",
          backgroundColor: "#EAECEF",
          overflow: "hidden",
        }}
      >
        {(isLoansProcessing ||
          isBorrowsProcessing ||
          doShowFullScreenLoader) && <SpinnerFullScreen></SpinnerFullScreen>}
        <div
          className="title-subHeaderTitle dtc-title py-2 my-1"
          style={{ paddingLeft: "0.5rem" }}
        >
          Recalls
        </div>
        <Card style={{ height: getCardHeight() }}>
          <CardContent className="h-100 pt-0 px-0">
            <hr className="my-0 ps-3 pe-3" style={{ width: "99.8%" }} />
            <div
              className="w-100 pb-0 pt-0 row kpi"
              style={{ backgroundColor: "#f0f8ff78" }}
            >
              <div className="col-3 d-flex align-items-center">
                <div className="globalfilterdiv globalSearch-globalFilter w-75 mt-0">
                  <input
                    type="search"
                    placeholder="Global search..."
                    id="filter-text-box"
                    onInput={onFilterTextChange}
                  />
                  <SearchIcon style={{ fontSize: "1rem", color: "#1e355e" }} />
                </div>
              </div>
              <div className="col-6">
                <KPIComponent ticker={selectedTicker} cusip={selectedTickerCusip}></KPIComponent>
              </div>
              <div className="col-3 d-flex  justify-content-end align-items-center pe-0">
                <div className="float-end d-flex align-items-center">
                  <button
                    type="button"
                    onClick={reset}
                    className="reset-btn d-flex btn reset-btn btn-primary align-self-center justify-content-center h-75"
                  >
                    Reset
                  </button>
                  <span
                    className="borrowExceldnld float-start ms-1"
                    onClick={onExcelExport}
                    title="Download Excel"
                  >
                    <img
                      src={excel}
                      alt=""
                      style={{
                        height: "1.8rem",
                        width: "1.8rem",
                        cursor: "pointer",
                      }}
                    />
                  </span>
                  <span
                    //  onClick={refreshAccount}
                    onClick={refreshAccountObj}
                    title="Refresh Data"
                    className="refresh-dtc float-end"
                  >
                    <RefreshIcon
                      style={{
                        color: "#1E355E",
                        marginRight: "0.5rem",
                        height: "1.6rem",
                        width: "1.6rem",
                        cursor: "pointer",
                      }}
                    />
                    <span className="refreshsettimedateContract">
                      <span>Last updated on: </span>
                      <span style={{ whiteSpace: "nowrap" }}>
                        {lastRefresh}
                      </span>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div className="ps-1">
              <hr className="my-0 ps-3 pe-3" style={{ width: "99.8%" }} />
            </div>
            <div
              className="grids-div mx-auto h-100"
              style={{ height: getGridsHeight() }}
            >
              <Split initialPrimarySize="40%">
                <div style={{ height: "100%" }}>
                  <BorrowRecallsGrid
                    applyBorrowMetricsFilters={setExternalBorrowFilters}
                    isResetFilters={isResetFilters}
                    rowData={borrows}
                    height={33.6}
                    title="Borrows"
                    globalSearch={globalSearch}
                    getBtnRef={(gridRef: any) => {
                      setRefBorrowRecalls(gridRef);
                    }}
                    getGridApi={(gridApi: any) => {}}
                    onRowSelected={(ticker: any, sec_id: number) => {
                      setSelectedTicker(ticker);
                      setSelectedTickerCusip(sec_id)
                       setSelectedCusip(sec_id);
                    }}
                    appliedFilterStateBorrowGrid={(filterState: any) => {
                      setAppliedFiltersBorrowsGrid(filterState);
                    }}
                    getContextMenuItems={getContextMenuItems}
                    filters={appliedFiltersBorrowsGrid}
                    onDataLoaded={() => {
                      // setIsBorrowsProcessing(false);
                    }}
                    openCount={borrowOpenCount}
                    pastDueCount={borrowPastDueCount}
                    past30dayDueCount={borrowPast30dayDueCount}
                    partialReturnCount={borrowPartialReturnCount}
                    fullReturnCount={borrowFullReturnCount}
                    nonOutstandingCount={borrowNonOutstandingCount}
                    insertRowId={insertedBorrowRowIds}
                  />
                </div>
                <div style={{ height: "100%" }}>
                  <LoanRecallsGrid
                    insertRowId={insertedLoanRowIds}
                    isResetFilters={isResetFilters}
                    rowData={loans}
                    applyLoanMetricFilters={setExternalLoanFilters}
                    recallCount={loanRecallCount}
                    terminateCount={loanTerminationCount}
                    height={33.6}
                    onRowSelected={(ticker: any, sec_id: number) => {
                      setSelectedTicker(ticker);
                      setSelectedTickerCusip(sec_id)
                    }}
                    title="Loans"
                    globalSearch={globalSearch}
                    getBtnRef={(gridRef: any) => {
                      setRefLoans(gridRef);
                    }}
                    getGridApi={(gridApi: any) => {}}
                    appliedFilterStateLoanGrid={(filterState: any) => {
                      setAppliedFiltersLoansGrid(filterState);
                    }}
                    filters={appliedFiltersLoansGrid}
                    openCount={loanOpenCount}
                    pastDueCount={loanPastDueCount}
                    past30dayDueCount={loanPast30dayDueCount}
                    partialReturnCount={loanPartialReturnCount}
                    fullReturnCount={loanFullReturnCount}
                    nonOutstandingCount={loanNonOutstandingCount}
                    getContextMenuItems={getContextMenuItems}
                    setSelectedRows={(rows: any) => {
                      setSelectedRows(rows);
                    }}
                    onRecall={onRecallClick}
                    isDeselectAll={isDeselectAll}
                    fullRecallCount={loanFullRecallCount}
                  />
                </div>
              </Split>
            </div>
          </CardContent>
        </Card>
      </div>
      <Modal
        size="lg"
        centered
        show={isRecallActivityPopup}
        onHide={() => onRecallActivityClose()}
        backdrop="static"
      >
        <Modal.Header
          style={{
            backgroundColor: "#6a7587",
            color: "#fff",
            height: "3rem",
          }}
          closeButton
        >
          <Modal.Title>
            Recall Activity ({lenderRefId}/{bl})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RecallActivity lender_ref_id={lenderRefId}></RecallActivity>
        </Modal.Body>
      </Modal>

      <div>
        <Modal
          size="xl"
          centered
          show={isContractRecallPopUpOpen}
          onHide={handleContractRecallClose}
          backdrop="static"
        >
          <Modal.Header
            style={{
              backgroundColor: "#6a7587",
              color: "#fff",
              height: "3rem",
            }}
            closeButton
          >
            <Modal.Title>Recall Contract</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ContractRecall
              selectedRows={rowsToRecall}
              setDoShowFullScreenLoader={setDoShowFullScreenLoader}
              doShowFullScreenLoader={doShowFullScreenLoader}
              handleContractRecallClose={handleContractRecallClose}
              user={props?.user}
              type={"Recall"}
              updateGridCells={() => {}}
            />
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default withUser(Recalls);
